import axios from 'axios';
import TMDB_BASE_URL from './TMDB_constant';
import apiLogger from '../apiLogger';
import TMDB_constant from './TMDB_constant';

export const TMDB_axios_adapter = axios.create({
    baseURL: TMDB_BASE_URL,
    timeout: 60 * 1000,
    headers: {
        'Content-Type': 'application/json',
    },
});

TMDB_axios_adapter.interceptors.request.use(
    (config) => {
        config.headers['Authorization'] = `${TMDB_constant.Authorization}`;
        return apiLogger.request(config);;
    },
    (error) => {
        return apiLogger.error(error);
    }
);

TMDB_axios_adapter.interceptors.response.use(
    (response) => {
        return apiLogger.response(response);
    },
    (error) => {
        return apiLogger.error(error);
    }
);
